import React, { useEffect, useState } from 'react';
import { Modal, Button, Spin } from 'antd';
import { Viewer } from '@toast-ui/react-editor';
import { toast } from 'react-toastify';
import { api } from '../../config/api';

const ExternalIorTermsPopup = ({ linkId, onLogout }) => {
    const [terms, setTerms] = useState(null); // null = loading
    const [showModal, setShowModal] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [termsLoaded, setTermsLoaded] = useState(false);

    // Unique storage key for this specific link
    const STORAGE_KEY = `external_terms_version_${linkId}`;

    const loadTerms = async () => {
    try {
        const res = await api.get(`/ior-ous-calculator/${linkId}/terms-conditions?search=tradeos`);
        const { data } = res.data;

        if (!data || data.length === 0) {
            // No terms → don't show modal at all
            setTerms({ content: '', version: '0' });
            setTermsLoaded(true);
            return;
        }

        setTerms(data[0]);
        setTermsLoaded(true);
    } catch (err) {
        console.error(err);
        setTerms({ content: '', version: '0' });
        setTermsLoaded(true);
    }
};

    useEffect(() => {
        if (linkId) {
            loadTerms();
        }
    }, [linkId]);

    useEffect(() => {
        if (!termsLoaded || !terms) return;

        const storedVersion = localStorage.getItem(STORAGE_KEY);
        const currentVersion = String(terms.version || '0');

        if (storedVersion === currentVersion) {
            setShowModal(false);
        } else {
            setShowModal(true);
            setIsNew(!!storedVersion);
        }
    }, [terms, termsLoaded, STORAGE_KEY]);

    const handleAccept = () => {
        const versionToStore = String(terms.version || '0');
        localStorage.setItem(STORAGE_KEY, versionToStore);
        setShowModal(false);
        toast.success('Terms accepted successfully.');
    };

    const handleReject = () => {
        toast.info('You must accept the Terms & Conditions to continue.');
        onLogout?.();
    };

    // If we are supposed to show the modal but terms are loading, show a spinner overlay
    if (showModal && !termsLoaded) {
        return (
            <Modal open footer={null} closable={false} centered>
                <div className="w-full flex flex-col items-center justify-center p-10">
                    <Spin size="large" />
                    <p className="mt-4 text-gray-500">Loading Terms & Conditions...</p>
                </div>
            </Modal>
        );
    }

    if (!showModal) return null;

    return (
        <Modal
            open={showModal}
            centered
            width={900}
            closable={false}
            maskClosable={false}
            title={
                <div className="flex flex-col">
                    <h2 className="text-xl font-semibold">
                        {isNew
                            ? "We’ve Updated Our Terms & Conditions"
                            : "Terms & Conditions"}
                    </h2>

                    {isNew && (
                        <p className="text-gray-500 mt-1 font-normal text-sm">
                            Please review and accept the updated terms to continue using this link.
                        </p>
                    )}
                </div>
            }
            footer={[
                <Button key="decline" danger onClick={handleReject}>
                    I Decline (Logout)
                </Button>,
                <Button key="accept" type="primary" onClick={handleAccept}>
                    I Accept
                </Button>,
            ]}
        >
            <div className="h-[60vh] overflow-y-auto border p-4 rounded-md bg-gray-50">
                {/* Use Viewer to render HTML/Markdown content */}
        {terms?.content ? (
                    <Viewer initialValue={terms.content} />
                ) : (
                    <div className="text-center py-12 text-gray-600">
                        No terms available at this time.
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ExternalIorTermsPopup;